// extracted by mini-css-extract-plugin
module.exports = {"JobsFeedV2":"styles_JobsFeedV2__sLWRN","count":"styles_count__ZaZyA","results":"styles_results__zGaKr","height":"styles_height__rScfT"};